import script from "./Paw.vue?vue&type=script&setup=true&lang=js"
export * from "./Paw.vue?vue&type=script&setup=true&lang=js"

import "./Paw.vue?vue&type=style&index=0&id=44e76644&lang=scss"

const __exports__ = script;

export default __exports__